export default "/images/jobless.png?238abb69e297f783de879620cdfcf85f";